import ConnectedStudyBrowser from '../../connectedComponents/ConnectedStudyBrowser';
import ConnectedCTStudyBrowser from '../../connectedComponents/ConnectedCTStudyBrowser';

export default {
  id: 'studies',
  getPanelModule() {
    return {
      menuOptions: [
        {
          icon: 'th-large',
          label: 'study',
          target: 'studies-panel',
          from: 'left',
        },
      ],
      components: [
        {
          id: 'studies-panel',
          component: ConnectedStudyBrowser,
        },
        {
          id: 'ct-studies-panel',
          component: ConnectedCTStudyBrowser,
        },
      ],
      defaultContext: ['VIEWER'],
    };
  },
};
